import { Observable, throwError as observableThrowError } from "rxjs";
import { catchError } from "rxjs/operators";
import { Injectable } from "@angular/core";

import { StoreService } from "./store.service";
import { environment } from "../../environments/environment";
import { HttpClient, HttpErrorResponse } from "@angular/common/http";

@Injectable()
export class ServerService {
  url: string = "https://api.speedspot.org/v2/servers?provider=w-sc-1";

  constructor(private http: HttpClient, private store: StoreService) {}

  getServer(): Observable<any> {
    return this.http
      .get(this.url)
      .pipe(
        catchError((error: HttpErrorResponse) =>
          observableThrowError(error.error || "Server error")
        )
      );
  }
}
